import { useTranslation } from "next-i18next";

import { PageLayout } from "@/components/layouts";
import { StatusPageContent } from "@/components/StatusPageContent";
import { getSiteSettings } from "@/services/sanity";
import { getAllTranslationsServerSide } from "@/utils/i18n";

export default function Error404() {
  const { t } = useTranslation();
  const linkText = t("back_home_CTA");
  const page = "HOME";
  const illustration = "confusedGrey";
  const title = "404";
  const contentTitle = t("error_generic");
  return (
    <PageLayout title={title} headerTheme="dark">
      <StatusPageContent
        title={contentTitle}
        linkText={linkText}
        page={page}
        illustration={illustration}
      />
    </PageLayout>
  );
}

export async function getStaticProps({ locale }) {
  const siteSettings = await getSiteSettings();

  return {
    props: {
      ...(await getAllTranslationsServerSide(locale)),
      siteSettings,
    },
  };
}
